// src/data/exercises/L3_02.js

const accountOptions = [
  '雑収入', '雑益', '雑損', '現金', '現金過不足'];

export const L3_02 = {
  title: '簿記　3級（第219-2回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {

      parts: [
        { type: 'ruby', text: '金庫', ruby: 'きんこ' },
        { type: 'text', value: 'の' },
        { type: 'ruby', text: '現金', ruby: 'げんきん' },
        { type: 'text', value: 'を' },
        { type: 'ruby', text: '数', ruby: 'かぞ' },
        { type: 'text', value: 'えたところ、' },
        { type: 'ruby', text: '実際有高', ruby: 'じっさいありだか' },
        { type: 'text', value: 'は￥77,130であった。なお、' },
        { type: 'ruby', text: '現金', ruby: 'げんきん' },
        { type: 'text', value: 'の' },
        { type: 'ruby', text: '帳簿残高', ruby: 'ちょうぼざんだか' },
        { type: 'text', value: 'は￥74,130であったので、' },
        { type: 'ruby', text: '不一致', ruby: 'ふいっち' },
        { type: 'text', value: 'の' },
        { type: 'ruby', text: '原因', ruby: 'げんいん' },
        { type: 'text', value: 'を' },
        { type: 'ruby', text: '調査', ruby: 'ちょうさ' },
        { type: 'text', value: 'することとした。' }
    ]
    
    ,
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '現金', debitAmount: 3000, creditAccount: '現金過不足', creditAmount: 3000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '実際有高は￥77,130であった。なお、現金の帳簿残高は￥74,130であった \n' },
          { type: 'text', value: '①帳簿残高を実際有高に合わせます。\n' },
          { type: 'text', value: '現金を増加（プラス）します。\n' },
          { type: 'styled', value: '現金の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '不一致の原因を調査することとした。\n' },
          { type: 'text', value: '②不一致の原因を調査する。\n' },
          { type: 'text', value: '現金過不足を使います。\n' },
          { type: 'styled', value: '現金を借方に記入するので、現金過不足は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]

      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`実際有高は￥77,130であった。なお、現金の帳簿残高は￥74,130であった
①帳簿残高を実際有高に合わせます。
現金を増加（プラス）します。

不一致の原因を調査することとした。
②不一致の原因を調査する。
現金過不足を使います。

`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
             parts: [
          { type: 'text', value: '実際有高は￥77,130であった。なお、現金の帳簿残高は￥74,130であった \n' },
          { type: 'text', value: '①帳簿残高を実際有高に合わせます。\n' },
          { type: 'text', value: '現金を増加（プラス）します。\n' },
          { type: 'styled', value: '現金の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '不一致の原因を調査することとした。\n' },
          { type: 'text', value: '②不一致の原因を調査する。\n' },
          { type: 'text', value: '現金過不足を使います。\n' },
          { type: 'styled', value: '現金を借方に記入するので、現金過不足は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};